import { messagesPath } from "@travily/routes";

export const AUTH_PROVIDERS = {
  google: "/auth/google_oauth2",
  facebook: "/auth/facebook",
} as const;

/**
 * The messages page keyed to a counterpart: `to` finds or starts that thread and redirects to it,
 * `draft` pre-seeds its composer without sending. Both are MessagesController params rather than
 * route segments, so no generated helper carries them.
 */
export function messageThreadHref(handle: string, draft?: string): string {
  const params = new URLSearchParams({ to: handle });
  if (draft) params.set("draft", draft);
  return `${messagesPath()}?${params.toString()}`;
}
